module.exports = "<div class=\"xo-end-content\" content>\n    <!-- find css for this page in public/css/pages -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-end/template.html
// module id = ./pages/xo-end/template.html
// module chunks = 0